// Initialize a new Lenis instance for smooth scrolling
const lenis = new Lenis();

// Synchronize Lenis scrolling with GSAP's ScrollTrigger plugin
lenis.on('scroll', ScrollTrigger.update);

// Add Lenis's requestAnimationFrame (raf) method to GSAP's ticker
// This ensures Lenis's smooth scroll animation updates on each GSAP tick
gsap.ticker.add((time) => {
  lenis.raf(time * 1000); // Convert time from seconds to milliseconds
});

// Disable lag smoothing in GSAP to prevent any delay in scroll animations
gsap.ticker.lagSmoothing(0);

document.addEventListener('DOMContentLoaded', function () {
  window.addEventListener(
    'scroll',
    function () {
      // The bar used to stay transparent for the first 200px (20px on
      // collections), so on any page whose content starts high — the mailing
      // list confirmation, for one — the page's own wordmark sat under a
      // transparent nav carrying the same wordmark. Solid on the first scroll
      // instead. A few pixels of tolerance rather than zero, so the class does
      // not flicker on sub-pixel movement at rest.
      document.body.classList.toggle('navbar--scrolled', window.scrollY > 4);
    },
    { passive: true },
  );

  document.querySelectorAll('.tt-carousel').forEach((carouselEl) => {
    const swiperEl = carouselEl.querySelector('.tt-carousel__swiper');
    const nextEl = carouselEl.querySelector('.tt-carousel__next');
    const prevEl = carouselEl.querySelector('.tt-carousel__prev');

    const swiper = new Swiper(swiperEl, {
      draggable: true,
      slidesPerView: 1,
      loop: true,
      spaceBetween: carouselEl.closest('.products-carousel') ? 57 : 24,
      grabCursor: true,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: carouselEl.closest('.tt-reviews') ? 2 : 3,
        },
      },
    });

    console.log(nextEl, prevEl);
  });

  document.querySelectorAll('.main-product__gallery').forEach((carouselEl) => {
    const swiperEl = carouselEl.querySelector('.swiper');
    const nextEl = carouselEl.querySelector('.tt-carousel__next');
    const prevEl = carouselEl.querySelector('.tt-carousel__prev');

    // console.log({ swiperEl });

    const swiper = new Swiper(swiperEl, {
      draggable: true,
      slidesPerView: 1,
      spaceBetween: 12,
      grabCursor: true,
      loop: true,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
    });

    window.addEventListener('product:variant-change', (e) => {
      const { variantId } = e.detail;

      // Not every slide is assigned to a variant — the rear shot is not, and it
      // renders data-variant-id="". Selecting a variant with no image of its own
      // used to throw here (querySelector returns null, .dataset on null), which
      // takes out the rest of the handler. Leave the gallery where it is instead.
      const slide = document.querySelector(`.main-product__image[data-variant-id='${variantId}']`);
      if (!slide) return;

      const variantImageIndex = Number(slide.dataset.index);
      if (Number.isNaN(variantImageIndex)) return;

      // The swiper is built with loop: true, where slideTo() addresses the
      // duplicated slide array rather than the real one.
      if (swiper.params.loop && typeof swiper.slideToLoop === 'function') {
        swiper.slideToLoop(variantImageIndex);
      } else {
        swiper.slideTo(variantImageIndex);
      }
    });
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('.js-cart-toggle')) {
      e.preventDefault();
      document.body.classList.toggle('tt-cart--show');
    } else if (e.target.closest('.js-cart-close')) {
      e.preventDefault();
      document.body.classList.remove('tt-cart--show');
    }
  });

  // Listen for the "liquid-ajax-cart:request-end" event which is fired
  // after a Shopify Cart API Ajax request is performed
  document.addEventListener('liquid-ajax-cart:request-end', (event) => {
    const { requestState } = event.detail;

    // If the "add to cart" request is successful
    if (requestState.requestType === 'add' && requestState.responseData?.ok) {
      // Add the CSS class to the "body" tag
      document.body.classList.add('tt-cart--show');
    }
  });

  document.querySelectorAll('.product-option__checkbox').forEach((el) => {
    el.addEventListener('change', function () {
      // variant updated

      const variantId = document.querySelector('.product-option__checkbox:checked').value;

      window.history.replaceState({}, '', `${window.location.pathname}${variantId ? `?variant=${variantId}` : ''}`);

      window.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variantId } }));

      // console.log({ variantId });
    });
  });

  document.querySelectorAll('.col--pdp-form').forEach((el) => {
    el.addEventListener('submit', () => {
      document.body.classList.add('tt-cart--show');
    });
  });

  /**
   * Community
   */
  // const communityTl = gsap.timeline({
  //   scrollTrigger: {
  //     trigger: '.community-cta',
  //     start: 'top top',
  //     end: '+=1000px',
  //     scrub: 1,
  //     invalidateOnRefresh: true,
  //   },
  // });
  // communityTl.fromTo(
  //   '.community-cta__images > img',
  //   {
  //     x: '100%',
  //   },
  //   {
  //     x: '-100%',
  //   },
  // );

  // const communityST = ScrollTrigger.create({

  // });

  // document.querySelectorAll('.community-cta__images > img').forEach((img) => {
  //   gsap.fromTo(
  //     img,
  //     {
  //       x: '0%',
  //     },
  //     {
  //       x: '-100px',
  //     },
  //   );
  // });

  document.querySelectorAll('.c-stories__slider').forEach((carouselEl) => {
    const swiperEl = carouselEl.querySelector('.swiper');
    const nextEl = carouselEl.querySelector('.tt-carousel__next');
    const prevEl = carouselEl.querySelector('.tt-carousel__prev');

    // console.log({ swiperEl });

    const swiper = new Swiper(swiperEl, {
      draggable: true,
      slidesPerView: 1,
      spaceBetween: 12,
      grabCursor: true,
      // loop: true,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },

      breakpoints: {
        768: {
          slidesPerView: 2,
        },
      },
    });

    console.log(swiper);
  });

  document.querySelectorAll('.tt-content__slider').forEach((carouselEl) => {
    const swiperEl = carouselEl.querySelector('.swiper');
    const nextEl = carouselEl.querySelector('.tt-carousel__next');
    const prevEl = carouselEl.querySelector('.tt-carousel__prev');

    // console.log({ swiperEl });

    const swiper = new Swiper(swiperEl, {
      draggable: true,
      slidesPerView: 1,
      spaceBetween: 20,
      grabCursor: true,
      // loop: true,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },

      breakpoints: {
        768: {
          slidesPerView: 1.5,
        },
      },
      on: {
        init: updateInfo,
        slideChange: updateInfo,
      },
    });

    function updateInfo() {
      const countEl = document.querySelector('.tt-content-carousel__aside strong');
      const infoEl = document.querySelector('.tt-content-carousel__aside span');
      const activeSlide = this.slides[this.activeIndex];

      infoEl.textContent = activeSlide.dataset.info;
      countEl.textContent = `${this.activeIndex + 1} OF ${this.slides.length}`;
    }

    console.log(swiper);
  });
});

(() => {
  document.querySelectorAll('.mobile-menu__btn').forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      document.body.classList.toggle('mobile-menu--show');
    });
  });
})();
